import React, { useContext, useEffect, useState } from "react";
import { useAuthContext } from "../../../../contexts/AuthContext.jsx";
import { getStats } from "../../../SF";
import "../../../../stats.css";
import StatComponent from "../StatComponent";
import SkeletonLoader from "../../../UI/SkeletonLoader";
import Loader from "../../../UI/Loader";

function Stats() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false); // Start as false
  const context = useAuthContext();
  const user = context?.user;

  useEffect(() => {
    if (!context || !user) {
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);
        const result = await getStats(context, "This Month");
        setData(result);
      } catch (error) {
        // Error handling without console.log
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [context, user]);

  const hasStats = data && data.Stats && Object.keys(data.Stats).length > 0;

  if (!context || !user) {
    return null;
  }

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          {hasStats ? (
            <StatComponent stats={data} title={"This Month"} />
          ) : (
            <div className="skeleton-grid">
              <SkeletonLoader type="card" count={4} />
              <SkeletonLoader type="card" count={3} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Stats;
